import * as React from "react"

export const DragIcon = (props: any) => {
  return (
    <svg width={34} height={34} viewBox="0 0 34 34" {...props}>
      <path d="M20 9H4v2h16V9zM4 15h16v-2H4v2z" />
    </svg>
  )
};